/**
 * A job's US state, resolved one way everywhere: the Career Wallet's "jobs in your state" demand
 * count, and state-aware credential matching (State EMS Certification, states that certify without
 * NREMT) in job match, the "Documents Reviewed" apply gate and the hiring checklist.
 *
 * Synced verbatim into functions/src/generated/ (scripts/syncFunctionsGenerated.mjs) so applyToJob
 * resolves the job's state exactly as the apply page does.
 */
import { US_STATES } from '../maps/usStates';

type AnyRecord = Record<string, unknown>;
const asRecord = (v: unknown): AnyRecord => (v && typeof v === 'object' ? (v as AnyRecord) : {});
const str = (v: unknown): string => (typeof v === 'string' ? v.trim() : '');

/** "FL", "fl" or "Florida" → "FL"; anything else → null. */
export function toStateCode(raw: unknown): string | null {
  const s = str(raw);
  if (!s) return null;
  const up = s.toUpperCase();
  const byCode = US_STATES.find((x) => x.code === up);
  if (byCode) return byCode.code;
  const byName = US_STATES.find((x) => x.name.toLowerCase() === s.toLowerCase());
  return byName ? byName.code : null;
}

/** A job's state: structured location first (jobLocation.stateCode → stateName → locationState), then "City, ST" text. */
export function jobStateCode(job: unknown): string | null {
  const j = asRecord(job);
  const loc = asRecord(j.jobLocation);
  const direct = toStateCode(loc.stateCode) ?? toStateCode(loc.stateName) ?? toStateCode(j.locationState);
  if (direct) return direct;
  const text = [str(j.locationText), typeof j.location === 'string' ? j.location : str(asRecord(j.location).name)].join(' ');
  const m = /,\s*([A-Z]{2})\b/.exec(text);
  return m ? toStateCode(m[1]) : null;
}
